import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    accId: null,
    accName: "",
    fromDate: null,
    toDate: null,
  },
  list: [],
  openingBalance: 0,
  closingBalance: 0,
  loading: false,
  loadingSearch: false,
  searchResults: [],
};

const intangibleAssetLedgerSlice = createSlice({
  name: "intangibleAssetLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setLedgerData: (state, action) => {
      state.list           = action.payload.ledger        || [];
      state.openingBalance = action.payload.opening_balance ?? 0;
      state.closingBalance = action.payload.closing_balance ?? 0;
    },
    setLoading: (state, action) => { state.loading = action.payload; },
    setLoadingSearch: (state, action) => { state.loadingSearch = action.payload; },
    setSearchResults: (state, action) => { state.searchResults = action.payload; },
    resetLedger: () => initialState,
  },
});

export const {
  setFilters, setLedgerData, setLoading,
  setLoadingSearch, setSearchResults, resetLedger,
} = intangibleAssetLedgerSlice.actions;

export default intangibleAssetLedgerSlice.reducer;